import { v4 } from 'uuid';

export type Uuid = string;

export const createUuid = v4;

export const nullUuid = '00000000-0000-0000-0000-000000000000' as Uuid;
